'use strict';

angular.module('enervexSalesappApp').factory('HubspotJobField', function ($resource) {
	// {productClasses, overrideFields} -- the HubSpot backed fields that live on
	// a job, for the job form and the job's HubSpot tab. Read only.
	return $resource('/api/hubspot-job-fields');
});
